import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sub?: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  sub,
  id,
  className = ''
}: CtaButtonProps) {
  return <div id={id} className={`flex w-full flex-col items-center ${className}`} data-id="element-103" data-mp="cl2cvzoa97jd">
      <a href={CHECKOUT_URL} className="flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-amber px-5 py-5 text-center font-display text-[22px] font-extrabold uppercase leading-tight tracking-wide text-ink shadow-[0_6px_0_0_#B45309] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-amber-hover active:translate-y-1 active:shadow-[0_2px_0_0_#B45309] focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60 sm:text-2xl" data-id="element-104" data-mp="cn5cnbf8mf1a">
        <span data-id="element-105" data-mp="159zstw50us8y">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-106" data-mp="15ardibx2z5kg" />
      </a>
      {sub && <p className="mt-4 text-center text-sm font-medium text-mist" data-id="element-107" data-mp="35yqsd7tp8f1x">{sub}</p>}
    </div>;
}